import { FC } from "react";
import { IconType } from "./types";

export const RefreshIcon: FC<IconType> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
  >
    <path
      d="M14.7015 5.79288C13.3432 4.43455 11.4182 3.65122 9.30154 3.86788C6.2432 4.17622 3.72654 6.65955 3.38487 9.71788C2.92654 13.7596 6.05154 17.1679 9.9932 17.1679C12.6515 17.1679 14.9349 15.6096 16.0015 13.3679C16.2682 12.8096 15.8682 12.1679 15.2515 12.1679C14.9432 12.1679 14.6515 12.3346 14.5182 12.6096C13.5765 14.6346 11.3182 15.9179 8.85154 15.3679C7.00154 14.9596 5.50987 13.4512 5.1182 11.6012C4.4182 8.36788 6.87654 5.50122 9.9932 5.50122C11.3765 5.50122 12.6099 6.07622 13.5099 6.98455L12.2515 8.24288C11.7265 8.76788 12.0932 9.66788 12.8349 9.66788H15.8265C16.2849 9.66788 16.6599 9.29288 16.6599 8.83455V5.84288C16.6599 5.10122 15.7599 4.72622 15.2349 5.25122L14.7015 5.79288Z"
      fill="black"
      fillOpacity="0.6"
    />
  </svg>
);
